export const SECURITIES_TABLE_NAME = "AvailableSecuritiesTable";

export const SECURITIES_TABLE_HEADER = ["ISIN", "Name", "Alias"];

export const SECURITIES_TABLE_ISIN_COL_IDX = 0;
export const SECURITIES_TABLE_NAME_COL_IDX = 1;
export const SECURITIES_TABLE_ALIAS_COL_IDX = 2;
